export { getCurrentConfiguration, getUrlWithHash } from "./getCurrentConfiguration";
